class urlApi
{      
       //urlServidor = "http://10.10.100.254:5145"; //Desarrollo       
       //urlServidor = "https://apiatc.ddns.net";
       urlServidor = "https://api3.sistemarms.com";
       api_url= this.urlServidor; 
       url_imagenes = this.urlServidor + "/api/Imagenes/GetImagenBase64/"
}
export default new urlApi();
